import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { axiosPrivate , axiosPrivateForamData} from "../../Helpers/axios";
import axios from "../../Helpers/axios";

const RECON_API_BASE_URL = process.env.REACT_APP_RECON_API_BASE_URL || 'https://uat-cou-recon-idfc.plutos.one/';


function* getAllAgentsDataResponse() {
  try {
    const token = sessionStorage.getItem("biller_access");

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = yield call(axios.get, `${RECON_API_BASE_URL}/cou-dashboard/customerpaymenthistory/all/agentsData`,

    );


    if (response.status === 200) {
      // Pass the entire data array to the success action
      yield put(actions.getAllAgentsDataSuccess(response.data.agents));
    } else {
      throw new Error(response.data.message || "Failed to fetch agents");
    }
  } catch (error) {
    console.error("Error fetching agents:", error);
    yield put(actions.getAllAgentsDataFailed(error.message));

    // Handle token expiration

  }
}



function* addAgentResponse({ payload: { data } }) {
  try {
    const token = sessionStorage.getItem("biller_access");
    if (!token) throw new Error("No authentication token found");

    // Make sure this matches your intended endpoint
    const response = yield call(
      axios.post,
      `${RECON_API_BASE_URL}/cou-dashboard/create`, // Your local endpoint
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      yield put(actions.addAgentsSuccess(response.data.message, response.data.data));
      yield put(actions.getAllAgentsData());
    } else {
      throw new Error(response.data?.message || "Failed to add agent");
    }
  } catch (error) {
    console.error("Error in addAgent saga:", error);
    const errorMsg =
      error.response?.data?.message || error.message || "Network error";
    yield put(actions.addAgentsFailed(errorMsg));

    if (error.response?.status === 401) {
      sessionStorage.removeItem("biller_access");
      localStorage.removeItem("module_access");
      window.location.href = "/login";
    }
  }
}

function* updateAgentResponse({ payload: { aiIdentifier, payload } }) {
    
  try {
    const token = sessionStorage.getItem("biller_access");
    if (!token) throw new Error("No authentication token found");

    // Ensure currentBalance is a number
    if (payload.currentBalance) {
      payload.currentBalance = Number(payload.currentBalance);
    }

    const response = yield call(
      axios.put,
      `${RECON_API_BASE_URL}/cou-dashboard/update/${aiIdentifier}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      yield put(actions.updateAgentDetailSuccess(
        aiIdentifier,
        response.data.message,
        payload
      ));
      yield put(actions.getAllAgentsData());
    } else {
      throw new Error(response.data?.message || "Failed to update agent");
    }
  } catch (error) {
    console.error("Error in updateAgent saga:", error);
    let errorMsg = "Failed to update agent";

    // Handle API validation errors
    if (error.response?.data?.message) {
      if (Array.isArray(error.response.data.message)) {
        errorMsg = error.response.data.message.join(", ");
      } else {
        errorMsg = error.response.data.message;
      }
    } else {
      errorMsg = error.message || "Network error";
    }

    yield put(actions.updateAgentDetailFailed(errorMsg));

 
  }
}



export default function* rootSaga() {

  yield all([takeEvery(actions.GET_AllAGENTS_DATA, getAllAgentsDataResponse)]);
  yield all([takeEvery(actions.ADD_AGENTS, addAgentResponse)]);
  yield all([takeEvery(actions.UPDATE_AGENT_DETAIL, updateAgentResponse)]);



}